import { Gift, Phone, MessageSquare, Instagram, MapPin, Mail } from "lucide-react";
import { Reveal } from "./Reveal";
import { BUSINESS } from "../../data";

export function Referral() {
  return (
    <section id="referral" className="bg-ink py-20 text-cream sm:py-28">
      <div className="mx-auto max-w-4xl px-5 text-center">
        <Reveal>
          <Gift size={30} className="mx-auto" />
          <h2 className="mt-5 font-display text-3xl leading-tight sm:text-5xl">Refer a friend</h2>
          <p className="mx-auto mt-5 max-w-xl text-cream/70">
            Send a friend my way. When they book their first detail and mention your
            name, you both get a discount on your next appointment. Simple.
          </p>
          <a
            data-testid="referral-cta"
            href={BUSINESS.smsHref}
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-cream px-8 py-4 text-sm font-bold uppercase tracking-widest text-ink transition-transform active:scale-95"
          >
            <MessageSquare size={16} /> Text me a referral
          </a>
        </Reveal>
      </div>
    </section>
  );
}

export function Footer() {
  return (
    <footer className="bg-cream py-16">
      <div className="mx-auto max-w-6xl px-5">
        <div className="flex flex-col items-center gap-6 text-center">
          <img src="/brand/logo.jpeg" alt="Pine & Shine" className="h-16 w-16 rounded-full object-cover" />
          <h2 className="font-display text-4xl leading-none sm:text-5xl">Pine &amp; Shine</h2>
          <p className="max-w-md text-ink/60">
            Questions? Call, text, or email — I&apos;ll get back to you fast. Booking
            notifications are handled by phone.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <a
              data-testid="footer-call"
              href={BUSINESS.phoneHref}
              className="inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3 text-sm font-bold uppercase tracking-widest text-cream"
            >
              <Phone size={16} /> {BUSINESS.phone}
            </a>
            <a
              data-testid="footer-sms"
              href={BUSINESS.smsHref}
              className="inline-flex items-center gap-2 rounded-full border border-ink/25 px-6 py-3 text-sm font-bold uppercase tracking-widest hover:bg-ink hover:text-cream"
            >
              <MessageSquare size={16} /> Text
            </a>
            <a
              data-testid="footer-email"
              href={BUSINESS.emailHref}
              className="inline-flex items-center gap-2 rounded-full border border-ink/25 px-6 py-3 text-sm font-bold uppercase tracking-widest hover:bg-ink hover:text-cream"
            >
              <Mail size={16} /> Email
            </a>
            <a
              data-testid="footer-instagram"
              href={BUSINESS.instagram}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-ink/25 px-6 py-3 text-sm font-bold uppercase tracking-widest hover:bg-ink hover:text-cream"
            >
              <Instagram size={16} /> Instagram
            </a>
          </div>
          <p className="mt-4 text-sm text-ink/60" data-testid="footer-email-text">{BUSINESS.email}</p>
          <p className="mt-6 flex items-center gap-2 text-xs uppercase tracking-widest text-ink/50">
            <MapPin size={14} /> Mobile service — we come to you
          </p>
          <p className="mt-2 text-xs font-semibold uppercase tracking-widest text-ink/60">Open by appointment · Closed Saturdays</p>
          <p className="mt-2 text-xs text-ink/40">© {new Date().getFullYear()} Pine &amp; Shine Detailing</p>
        </div>
      </div>
    </footer>
  );
}
